import anime from "animejs";
import { createContext, useEffect, useState } from "react";

import GlobalLoading from "Components/Global/GlobalLoading";

export const GlobalLoadingContext = createContext();

export const GlobalLoadingProvider = ({ render, setRender, children }) => {
  const [loading, setLoading] = useState(false);
  const [usePercentage, setUsePercentage] = useState(false);
  const [percentage, setPercentage] = useState(0);
  const [useStep, setUseStep] = useState(false);
  const [step, setStep] = useState("");

  useEffect(() => {
    anime({
      targets: ".loading",
      opacity: loading ? 1 : 0,
      duration: 3000,
    });
  }, [loading]);

  return (
    <GlobalLoadingContext.Provider
      value={{
        loading,
        setLoading,
        usePercentage,
        setUsePercentage,
        percentage,
        setPercentage,
        useStep,
        setUseStep,
        step,
        setStep,
      }}
    >
      {loading && (
        <GlobalLoading
          global
          render={render}
          setRender={setRender}
          usePercentage={usePercentage}
          percentage={percentage}
          useStep={useStep}
          step={step}
        />
      )}
      {children}
    </GlobalLoadingContext.Provider>
  );
};
